export default {
  getSaleDetail: '/v3/mallcenter/getSaleDetail',
  checkStock: '/gateway/capp/mallcenter/order/checkStock',
  getSpuParamStock: '/v3/mallcenter/getSpuParamStock',
  getSalePrices: '/v3/mallcenter/getSalePrices'
}
